import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc24666"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-json-dialog" }
const _hoisted_2 = { class: "preview" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出 JSON")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭")

import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportJSON',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const { slides } = storeToRefs(useSlidesStore())
const { exportJSON } = useExport()

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("pre", null, _toDisplayString(_unref(slides)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exportJSON)()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})